module.exports = __webpack_public_path__ + "img/bannerGreen.96c31b9b.jpg";